import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { read } from 'actions/data'
import { AccountMinus, AccountPlus } from 'mdi-material-ui'
import { Auth } from 'utils/Auth'
import { setNeedsFollowUp, clearNeedsFollowUp } from 'actions/inbox'
import API_URL from 'utils/ApiUrl'

const FollowUpButton = ({
  read,
  needsFollowUp,
  contactID,
  setNeedsFollowUp,
  clearNeedsFollowUp,
}) => {
  useEffect(() => {
    // Code here will run once when the component mounts
    console.log('FollowUpButton.js useEffect = Component did mount!')
  }, [])

  useEffect(() => {
    console.log('contactID changed: ', contactID)

    const getNeedsFollowUp = async () => {
      console.log('getNeedsFollowUp')
      try {
        const session = await Auth.currentSession()
        const response = await fetch(
          `${API_URL}/inbox/needsfollowup/${contactID}`,
          {
            cache: 'no-cache',
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${session.idToken.jwtToken}`,
            },
            method: 'GET',
            mode: 'cors',
            redirect: 'follow',
            referrer: 'no-referrer',
          },
        )

        const data = await response.json()

        if (!response.ok) {
          // clearNeedsFollowUp(contactID)
          return { notOk: true, ...data }
        }

        setNeedsFollowUp(contactID)

        return data
      } catch (error) {
        console.error('Error getting needsfollowup: ', error)
      }
    }

    if (contactID) {
      getNeedsFollowUp()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactID])

  const Icon = needsFollowUp ? AccountMinus : AccountPlus

  console.log('FollowUpButton.js render')

  const handleAction = async (contactID, actionType) => {
    let endpoint
    let action

    // Determine the appropriate endpoint and action based on the actionType
    switch (actionType) {
      case 'setNeedsFollowUp':
        endpoint = `${API_URL}/inbox/needsfollowup/set/${contactID}`
        action = setNeedsFollowUp
        break
      case 'clearNeedsFollowUp':
        endpoint = `${API_URL}/inbox/needsfollowup/clear/${contactID}`
        action = clearNeedsFollowUp
        break
      default:
        return
    }

    try {
      const session = await Auth.currentSession()
      const response = await fetch(endpoint, {
        cache: 'no-cache',
        headers: {
          'content-type': 'application/json',
          authorization: `Bearer ${session.idToken.jwtToken}`,
        },
        method: 'PUT',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer',
      })

      const data = await response.json()
      if (!response.ok) {
        return { notOk: true, ...data }
      }

      action(contactID)
      console.log('data: ', data)

      return data
    } catch (error) {
      console.error('Error handling request:', error)
    }
  }

  if (!contactID || contactID === 'new') return null

  return (
    <Button
      color="secondary"
      variant={needsFollowUp ? 'outlined' : 'contained'}
      onClick={() =>
        handleAction(
          contactID,
          needsFollowUp ? 'clearNeedsFollowUp' : 'setNeedsFollowUp',
        )
      }
    >
      <Icon style={{ marginRight: needsFollowUp ? 4 : 10 }} />
      {needsFollowUp ? 'Remove from follow up list' : 'Add to follow up list'}
    </Button>
  )
}

export default connect(
  (state, { contactID }) => ({
    // needsFollowUp: Boolean(state.data['inbox/needsfollowup']?.[contactID]),
    needsFollowUp: Boolean(
      state.inbox.conversationsListCursor.needsfollowup?.data?.[contactID],
    ),
  }),
  dispatch =>
    bindActionCreators(
      { read, setNeedsFollowUp, clearNeedsFollowUp },
      dispatch,
    ),
)(FollowUpButton)
